/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IndexSearchKey } from './indexSearchKey';


export interface IndexSearchFilter { 
    /**
     * An optional boolean flag that specifies if the search filter is an exclusion filter that excludes items from the search results                
     */
    isExclusionSearchFilter?: boolean;
    /**
     * A list of index search keys. Multiple search keys are supported which are OR-ed
     */
    indexSearchKeys?: Array<IndexSearchKey>;
}
